/**
 * Repair filenames that were UTF-8 encoded but decoded as Latin-1 somewhere in
 * the upload pipeline (multer/busboy decode multipart filenames as latin1), which
 * turns Arabic like "تقرير" into "ØªÙØ±ÙØ±".
 *
 * Safe and idempotent by construction — it only rewrites a string when BOTH:
 *  - every code point is in the 0x00–0xFF range (a real Unicode char, e.g. an
 *    already-correct Arabic name, has code points > 0xFF and is returned as-is);
 *  - reading those code points as bytes yields *valid* UTF-8 (a genuine Latin-1
 *    name like "café" fails the strict decode and is left untouched).
 *
 * Correct names, ASCII names, and legitimate Latin-1 names all pass through
 * unchanged; only true UTF-8-as-Latin-1 mojibake is recovered.
 */
export function fixFilenameMojibake(name: string | null | undefined): string {
  if (!name) return name ?? '';

  // Any real Unicode code point → the name is already correct, not mojibake.
  for (let i = 0; i < name.length; i += 1) {
    if (name.charCodeAt(i) > 0xff) return name;
  }

  try {
    const bytes = Uint8Array.from(name, (ch) => ch.charCodeAt(0));
    const decoded = new TextDecoder('utf-8', { fatal: true }).decode(bytes);
    // ASCII (and any name whose bytes were already the intended UTF-8) decodes
    // back to itself — only genuine mojibake actually changes.
    return decoded;
  } catch {
    // Not valid UTF-8 when read as bytes → genuine Latin-1 text, keep as-is.
    return name;
  }
}
